import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { useGetHashtagFollowListQuery, useGetStaticHashtagFollowListQuery } from 'services';
import useAuthStore from 'store/auth';
import { useNavigate } from 'react-router-dom';
import useUserStore from 'store/user';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';
import { withAuth } from 'utils';

const HashtagsBox: React.FC = () => {
	const { translate } = useTranslate();
	const navigate = useNavigate();
	const { user, token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const { followedHashTags, setFollowedHashTags }: Record<string, any> = useUserStore(
		(state) => state,
	);
	const payload: any = {
		limit: 6,
		page: 1,
		id: user?.userId,
	};
	const { data: { docs = [] } = {} } = token
		? useGetHashtagFollowListQuery(payload)
		: useGetStaticHashtagFollowListQuery(payload);

	// Effect to update followedHashTags when docs change
	useEffect(() => {
		if (docs.length > 0) {
			setFollowedHashTags(docs); // Update followedHashTags in the store
		} else {
			setFollowedHashTags([]);
		}
	}, [docs.length, setFollowedHashTags]);

	const sendToListing = () => {
		navigate(`/${user.userType}/followings-list?activeTab=hashtag&value=`);
	};

	const goToDetailPage = (id: any) => {
		navigate(`/hashtag/profile/${id}`);
	};
	return (
		<>
			{followedHashTags?.length > 0 ? (
				<div className="hashtags white-box bg-white">
					<div className="heading d-flex align-items-center justify-content-between">
						<h5 className="fw-bold mb-0">{translate('Social.hashtagsYouFollow')}</h5>
						<Button
							onClick={withAuth(token, sendToListing)}
							className="transparent-btn mb-0 rounded-pill lh-1"
						>
							{translate('Button.seeMore')}
						</Button>
					</div>
					<div className="hashtags-list d-flex flex-wrap">
						{followedHashTags?.map(
							(res: any, index: any) =>
								index < 6 && (
									<div
										onClick={withAuth(token, () => goToDetailPage(res?.id))}
										key={`${res?.hashTag}-${res?.id}`}
										className="hashtags-box rounded-pill"
										style={{ cursor: 'pointer' }}
									>
										#{res?.hashTag}
									</div>
								),
						)}
					</div>
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default HashtagsBox;
